import { Component, HostListener } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from 'src/environments/environment';
import { AppService } from '@app/app.service';
import { MatIconModule } from '@angular/material/icon';


@Component({
  selector: 'app-account',
  imports: [
    MatButtonModule,
    RouterLink,
    MatTooltipModule,
    MatIconModule
],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {

  user: any = null;
  additionalEmails: any[] = [];

  allowNameChange = environment.allowNameChange;
  allowEmailChange = environment.allowEmailChange;
  allowCellPhoneChange = environment.allowCellPhoneChange;
  allowDeleteAccount = environment.allowDeleteAccount;


  isMobile = window.innerWidth < 768;

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < 768;
  }

  constructor(
    private authService: AuthService,
    private appService: AppService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.authService.getUser().subscribe({
      next: (success) => {
        if (success.data) {
          this.authService.setUserToStorage(success.data);
          this.user = success.data;
          this.additionalEmails = success.data.additional_emails ?? [];
        }
      },
      error: (error) => {
        this.appService.handleError(error);
        this.user = null;
        this.additionalEmails = [];
      },
    });
  }

  formatPhoneNumber(phone: string) {
    if (phone) {
      return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    return '';
  }

  deleteAdditionalEmail(email: any): void {

    this.appService
      .confirm(`Are you sure you want to delete ${email.email} from your account?`)
      .subscribe((result) => {
        if (!result) return;

        this.appService.delete(`user/additional-emails/${email.id}`).subscribe({
          next: (response) => {
            this.appService.showSnackBar(response.message, 'success');

            this.additionalEmails = this.additionalEmails.filter(
              (item) => item.id !== email.id
            );
          },
          error: (error) => {
            this.appService.handleError(error);
          },
        });
      });
  }

}
